import React from "react";
import { FiCheckCircle, FiArrowLeft } from "react-icons/fi";
import { Link } from "react-router-dom";
import logo from "./assets/hallef-logo-cropped.png";
import "./success-state.css";

export default function SuccessState({ message, onContinue } = {}) {
  return (
    <main className="success-state-page" aria-labelledby="success-state-title">
      <Link to="/" aria-label="Hallef Technologies home">
        <img className="success-state-logo" src={logo} alt="Hallef Technologies" />
      </Link>
      <section className="success-state-card">
        <div className="success-state-icon" aria-hidden="true"><FiCheckCircle /></div>
        <p className="success-state-eyebrow">ALL DONE</p>
        <h1 id="success-state-title">Completed successfully!</h1>
        <p className="success-state-description">
          {message || "Your request has been completed. You're all set to continue exploring."}
        </p>
        {onContinue && <button className="success-state-home" type="button" onClick={onContinue}>Continue</button>}
        <Link className="success-state-home" to="/">
          <FiArrowLeft aria-hidden="true" /> Back to Home
        </Link>
      </section>
      <p className="success-state-footer">Hallef Technologies</p>
    </main>
  );
}
